import React, { Component } from 'react';
import SwaggerLine from './SwaggerLine';
import { ListGroup } from 'react-bootstrap';

class SwaggersList extends Component {
  groupView = (group, index) => {
    return (
      <div key={group.id}>
        <h3>{group.name}</h3>
        <ListGroup className="swagger-view-listgroup">
          {this.props.swaggers[index] ? this.props.swaggers[index].map(this.swaggerView(group)) : []}
        </ListGroup>
      </div>
    );
  }

  swaggerView = (group) => {
    return (swagger, index) => {
      return (
        <SwaggerLine
          key={swagger.id}
          swagger={swagger}
          group={group}
          loadSwagger={this.props.loadSwagger}/>
      );
    }
  }

  render() {
    return (
      <div>
        {this.props.groups.map(this.groupView)}
      </div>
    );
  }
}

export default SwaggersList;



// WEBPACK FOOTER //
// ./src/components/swagger-view/side-panel/SwaggersList.js